import React from "react";
import BlogOverview from "../components/BlogOverview/BlogOverview";
import { useInfiniteQuery } from "react-query";
import { fetchFilterData } from "../api";
import LoadingButton from "../components/LoadingButton/LoadingButton";

function Blog({ title }) {
  const limit = 6;

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useInfiniteQuery(
      ["blogoffset"],
      async ({ pageParam = 0 }) => {
        return fetchFilterData("blogoffset", pageParam, limit);
      },
      {
        getNextPageParam: (lastPage, allPages) => {
          // Wenn weniger als limit Elemente kamen, ist Schluss
          if (lastPage.length < limit) return undefined;
          return allPages.length; // nächste page
        },
      }
    );

  const allItems = data?.pages.flat() || [];

  return (
    <>
      <h1 className="text-light text-center">{title}</h1>

      <BlogOverview data={allItems} category="blog" title="Blog" />

      {hasNextPage && (
        <div className="text-center mt-6">
          <LoadingButton
            onClick={() => fetchNextPage()}
            loading={isFetchingNextPage}
          />
        </div>
      )}
    </>
  );
}

export default Blog;
